// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfileCardModale_container__BWBDs","appear":"ProfileCardModale_appear__1Chei","grid":"ProfileCardModale_grid__22SA-","cross":"ProfileCardModale_cross__1G_Zx"};